import { render } from "./patient-dashboard.vue?vue&type=template&id=6097b6fe"
import script from "./patient-dashboard.vue?vue&type=script&lang=js"
export * from "./patient-dashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__